import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api } from "@/lib/api";
import { AlertTriangle } from "lucide-react";

export default function AdminCheatingLogs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/cheating-logs").then((r) => setItems(r.data || [])); }, []);
  return (
    <DashboardLayout>
      <h1 className="heading text-2xl font-bold">Cheating Monitor</h1>
      <p className="text-sm text-slate-500 mt-1">Real-time violation logs from exam attempts.</p>
      <div className="mt-6 rounded-xl border border-slate-200 bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left">
            <tr>
              <th className="p-3 font-semibold">Time</th>
              <th className="p-3 font-semibold">Student</th>
              <th className="p-3 font-semibold">Type</th>
              <th className="p-3 font-semibold">Details</th>
            </tr>
          </thead>
          <tbody>
            {items.map((l) => (
              <tr key={l.id} className="border-t border-slate-100" data-testid={`log-${l.id}`}>
                <td className="p-3 text-xs text-slate-500 font-mono">{new Date(l.timestamp).toLocaleString()}</td>
                <td className="p-3 font-semibold">{l.user_name}</td>
                <td className="p-3"><span className="text-[10px] font-bold uppercase px-2 py-1 rounded bg-red-100 text-red-700">{l.type}</span></td>
                <td className="p-3 text-slate-600">{l.details}</td>
              </tr>
            ))}
            {items.length === 0 && (
              <tr><td colSpan={4} className="p-14 text-center text-slate-500">
                <AlertTriangle size={36} className="mx-auto text-slate-300" />
                <div className="mt-3">No violations detected.</div>
              </td></tr>
            )}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
}
